import React from "react";
import styled from "styled-components";

export default styled.select`
    line-height: 24px;
    width: 100%;
    text-align: center;
    display: block;
    border: 2px solid lightgrey;
    box-sizing: border-box;
    text-align: left;
    
    color: #717198;
    height: 38px;
    font-size: 16px;
    padding: 4px 11px;
   margin-bottom: 8px;
    border: .5px solid lightgrey;
`;